import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { NgSelectModule } from '@ng-select/ng-select';
import { MojoEditorModule } from 'mojo-editor';

import { CandidateSourceComponent } from './candidate-source.component';

@NgModule({
  declarations: [CandidateSourceComponent],
  imports: [
    NgSelectModule,
    ReactiveFormsModule,
    CommonModule,
    MatSelectModule,
    MatInputModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
  ],
  exports: [CandidateSourceComponent],
})
export class CandidateSourceModule {}
